import { OWNER_BORDER, OWNER_PANEL } from './ownerTheme'

type SimpleTableProps = {
  title: string
  columns: string[]
  rows: string[][]
  actionLabel?: string
  actionDisabled?: boolean
  onRowClick?: (row: string[], rowIndex: number) => void
}

export default function SimpleTable({
  title,
  columns,
  rows,
  actionLabel = 'Export CSV',
  actionDisabled = true,
  onRowClick,
}: SimpleTableProps) {
  return (
    <div className="rounded-2xl border p-4" style={{ borderColor: OWNER_BORDER, backgroundColor: OWNER_PANEL }}>
      <div className="flex items-center justify-between">
        <div className="text-sm font-semibold text-white">{title}</div>
        <button
          type="button"
          disabled={actionDisabled}
          className="rounded-lg border px-3 py-1 text-xs text-white/60 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--owner-accent)] disabled:opacity-50"
          style={{ borderColor: OWNER_BORDER }}
        >
          {actionLabel}
        </button>
      </div>
      <div className="mt-3 overflow-x-auto">
        <table className="min-w-full text-left text-sm text-white/80">
          <thead className="text-xs uppercase tracking-wide text-white/45">
            <tr>
              {columns.map((col) => (
                <th key={col} className="py-2 pr-4">
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {rows.map((row, idx) => (
              <tr
                key={`${idx}`}
                onClick={onRowClick ? () => onRowClick(row, idx) : undefined}
                onKeyDown={
                  onRowClick
                    ? (event) => {
                        if (event.key === 'Enter') onRowClick(row, idx)
                      }
                    : undefined
                }
                tabIndex={onRowClick ? 0 : undefined}
                className={
                  onRowClick
                    ? 'cursor-pointer hover:bg-white/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--owner-accent)]'
                    : undefined
                }
              >
                {row.map((cell, cellIdx) => (
                  <td key={`${idx}-${cellIdx}`} className="py-2 pr-4 text-white/70">
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
